module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.record.referrers.length > 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": ""
    }
  }, [_vm._l((_vm.record.referrers), function(referrer) {
    return _c('v-list-tile', {
      key: referrer.id
    }, [_c('v-list-tile-action', [_c('v-menu', {
      attrs: {
        "offset-y": ""
      }
    }, [_c('template', {
      slot: "activator"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.changeCurrent(referrer)
        }
      }
    }, [(referrer.is_current_referrer) ? _c('v-list-tile-title', [_vm._v("\n             Not curent referrer")]) : _c('v-list-tile-title', [_vm._v("\n             Make curent referrer")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.markedForDelete = referrer;
          _vm.showRemoveConfirmation = true
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('buttons.remove')))])], 1)], 1)], 2)], 1), _vm._v(" "), (referrer.therapist) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(referrer.therapist.title) + "\n          " + _vm._s(referrer.therapist.initials) + "\n          " + _vm._s(referrer.therapist.first_name) + "\n          " + _vm._s(referrer.therapist.last_name) + ".\n          "), _c('small', [_vm._v(_vm._s(referrer.therapist.reference_number))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.$t('added')) + ": " + _vm._s(_vm.dateformat(referrer.created_date)) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-action', [(referrer.is_current_referrer) ? _c('v-icon', [_vm._v("check")]) : _vm._e(), _vm._v(" "), (referrer.is_current_referrer) ? _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.$t('current')))]) : _vm._e()], 1)], 1)
  }), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    staticClass: "my-0",
    attrs: {
      "indeterminate": "",
      "height": "3"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showReferralPicker = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("Add a referrer")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.showReferralPicker),
      callback: function($$v) {
        _vm.showReferralPicker = $$v
      },
      expression: "showReferralPicker"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.pickerTouch++
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("home")])], 1), _vm._v("\n    Choose a referrer\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showReferralPicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('referral-picker', {
    attrs: {
      "touch": _vm.pickerTouch
    },
    on: {
      "selected": _vm.addReferrer,
      "close": function($event) {
        _vm.showReferralPicker = false
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.showRemoveConfirmation),
      callback: function($$v) {
        _vm.showRemoveConfirmation = $$v
      },
      expression: "showRemoveConfirmation"
    }
  }, [(_vm.markedForDelete && _vm.markedForDelete.therapist) ? _c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('dialogs.confirmremove.title')))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n      Remove\n      "), _c('strong', [_vm._v(_vm._s(_vm.markedForDelete.therapist.first_name) + " " + _vm._s(_vm.markedForDelete.therapist.last_name))]), _vm._v("\n      as a referrer for this record.\n      "), _c('v-alert', {
    attrs: {
      "type": "info",
      "value": true,
      "dismissible": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('dialogs.confirmremove.notes.p1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('dialogs.confirmremove.notes.p2')))])])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showRemoveConfirmation = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.removeRequest.loading,
      "color": "error"
    },
    on: {
      "click": function($event) {
        return _vm.removeReferrer(_vm.markedForDelete.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.remove')))])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-593c562f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/Referrers.vue
// module id = 1435
// module chunks = 9